var fetchUserPreferences = require('./fetch-user-preferences');
var getUser = require('./get-user');
var fetchSubscriptions = require('./fetch-subscriptions');

var PREMIUM_B2C_TYPES = ['bronze', 'silver', 'gold'];

function getUserInfo() {
  return getUser({ useCachedData: true })
    .then(function (userData) {
      return Promise.all([
          fetchUserPreferences(),
          fetchSubscriptions({ typeIn: PREMIUM_B2C_TYPES })
        ])
        .then(function (data) {
          var userProperties = data[0].body;
          var subscriptions = data[1].body;

          return {
            userProperties: userProperties,
            premiumSubscriptions: subscriptions,
            userData: userData,
          }
        });
    })
    .then(function (data) {
      return {
        subscriptions: data.premiumSubscriptions,
        isUserAuthenticated: Boolean(data.userData && data.userData.id),
      };
    })
    .catch((error) => {
      var isAuthError =  [401, 404].includes(error.response.xhr.status);

      return {
        subscriptions: [],
        isUserAuthenticated: !isAuthError
      };
    });
}

module.exports = getUserInfo;
